var sika = sika || {};
( function () {
    'use strict';
    sika.productsheet = {
        debug: true,
        loaded: false,
        context: ( function () {
            var returnValue = '';
            if ( jQuery( '.js-e-productlist-v2' ).length > 0 ) {
                returnValue = 'list';
            }
            else if ( jQuery( '.js-e-product' ).length > 0 ) {
                returnValue = 'details';
            }
            else if ( jQuery( '.js-sika-shoefinder' ).length > 0 ) {
                returnValue = 'shoefinder';
            }
            return returnValue;
        } )(),
        selectedColorCode: '',
        lang: jQuery( 'body' ).data( 'culture' ),
        pdfTitle: '',
        brandLogo: {
            width: 0,
            height: 0
        },
        clientLogo: {
            width: 0,
            height: 0
        },
        footer: {
            logo: '',
            text: ''
        },
        allPromises: function ( array ) {
            var deferred  = jQuery.Deferred();
            var fulfilled = 0,
                length = array.length;
            var results   = [];
            if ( length === 0 ) {
                deferred.resolve( results );
            }
            else {
                array.forEach( function ( promise, i ) {
                    jQuery.when( promise() ).then( function ( value ) {
                        results[ i ] = value;
                        fulfilled++;
                        if ( fulfilled === length ) {
                            deferred.resolve( results );
                        }
                    } );
                } );
            }
            return deferred.promise();
        },
        testDevice: function () {
            if ( sika.utils.isTouchDevice() === true ) {
                jQuery( '.js-hidden-touch' ).hide();
            }
        },
        addCheckboxes: function () {
            jQuery( document ).on( 'click', '.js-create-datasheet',function () {
                if ( !jQuery( this ).is( ':checked' ) ) {
                    sika.productsheet.clearlist();
                }
                else {
                    jQuery( '.js-e-products-loading-overlay' ).addClass( 'is-loading' );
                    sessionStorage.setItem( 'sika.pdfgen.active', 'true' );
                    sessionStorage.setItem( 'sika.pdfgen.logoActive', 'false' );
                    location.reload();
                    return false;
                }
            } );
            jQuery( document ).on( 'click', '.js-create-datasheet-clientlogo',function () {
                if ( !jQuery( this ).is( ':checked' ) ) {
                    sika.productsheet.clearlist();
                }
                else {
                    jQuery( '.js-e-products-loading-overlay' ).addClass( 'is-loading' );
                    sessionStorage.setItem( 'sika.pdfgen.logoActive', 'true' );
                    location.reload();
                    return false;
                }
            } );
        },
        getScripts: function ( jType, jProducts ) {
            console.log('sika.productsheet.loaded', sika.productsheet.loaded);
            if(sika.productsheet.loaded === false){
                jQuery( '.js-data-uries' ).first().load( '/system/data/data-uries #js-data-uries', function () {
                    sika.productsheet.loaded = true;
                    jQuery.ajax( {
                        url: '/Files/Templates/Designs/sika/_assets/js/vendor/pdfmake.js?v=1.01',
                        dataType: 'script',
                        cache: true
                    } ).done( function () {
                        jQuery.ajax( {
                            url: '/Files/Templates/Designs/sika/_assets/js/vendor/vfs_fonts.js',
                            dataType: 'script',
                            cache: true
                        } ).done( function () {
                            if ( jType === 'details' ) {
                                sika.productsheet.getPDFdata( jProducts, null, sika.productsheet.generatesingle, sika.productsheet.selectedColorCode );
                            }
                            if ( jType === 'list' ) {
                                sika.productsheet.generatelist( jProducts );
                            }
                        } ).fail( function ( error ) {
                            console.error( error );
                        } );
                    } ).fail( function ( error ) {
                        console.error( error );
                    } );
                } );
            } else{
                if ( jType === 'details' ) {
                    sika.productsheet.getPDFdata( jProducts, null, sika.productsheet.generatesingle, sika.productsheet.selectedColorCode );
                }else if ( jType === 'list' ) {
                    sika.productsheet.generatelist( jProducts );
                }
            }
            
        },
        getPDFdata: function ( prodID, variantID, callback, variantColor ) {
            jQuery.ajax( {
                url: '/system/data/pdf',
                type: 'GET',
                data: {
                    productid: prodID.indexOf( '-' ) > -1 ? prodID.split( '-' )[ 0 ] : prodID,
                    variantid: variantID,
                    pdfContext: sika.productsheet.context,
                    pdfColor: variantColor
                }
            } )
                    .done( function ( data ) {
                        if ( sika.productsheet.debug ) {
                            console.log( data );
                        }
                        sika.productsheet.footer.logo = data.footerLogo;
                        sika.productsheet.footer.text = data.footerText;
                        callback( data, prodID );
                    } )
                    .fail( function ( error ) {
                        console.error( error );
                    } );
        },
        checkList: function () {
            if ( jQuery( '.js-e-productlist-v2' ).length ) {
                var jLocalAllItems      = Object.keys( sessionStorage ),
                    shortGenerateButton = false;
                for ( var s = 0; s < jLocalAllItems.length; s++ ) {
                    if ( jLocalAllItems[ s ].indexOf( 'sika.pdfgen.' + sika.productsheet.context + '.item.' ) > -1 ) {
                        shortGenerateButton = true;
                    }
                }
                if ( jLocalAllItems.length > 0 ) {
                    var jLocalConvertedItems = sika.productsheet.convertLocalItems( jLocalAllItems );
                    //console.log('checkList',jLocalConvertedItems)
                    for ( var i = 0; i < jLocalConvertedItems.length; i++ ) {
                        jQuery( '.js-e-productlist-v2' ).find( '.js-sika-productsheet-list-add[value="' + jLocalConvertedItems[ i ] + '"]' ).prop( 'checked', true );
                    }
                    if ( shortGenerateButton === true ) {
                        jQuery( '.js-sika-productsheet-generate' ).removeClass( 'd-none' );
                    }
                    jQuery( '.js-e-productlist-v2' ).find( '.js-sika-productsheet-list-add-wrap' ).show();
                }
                if ( sessionStorage.getItem( 'sika.pdfgen.active' ) === 'true' && sessionStorage.getItem( 'sika.pdfgen.logoActive' ) !== 'true' ) {
                    jQuery( '.js-create-datasheet' ).prop( 'checked', true );
                    jQuery( '.js-create-datasheet-clientlogo' ).prop( 'checked', false );
                    jQuery( '.js-e-productlist-v2' ).find( '.js-sika-productsheet-list-add-wrap' ).show();
                }
                else if ( sessionStorage.getItem( 'sika.pdfgen.logoActive' ) === 'true' ) {
                    jQuery( '.js-create-datasheet-clientlogo' ).prop( 'checked', true );
                    jQuery( '.js-create-datasheet' ).prop( 'checked', false );
                    if ( sessionStorage.getItem( 'sika.pdfgen.clientLogo' ) === null ) {
                        jQuery( '.pdf-client-logo-file' ).slideToggle( 'fast' );
                    }
                    else {
                        jQuery( '.pdf-client-logo-file' ).slideToggle( 'fast' );
                        jQuery( '.file-upload-wrapper' ).hide();
                        var sessionLogo = JSON.parse( sessionStorage.getItem( 'sika.pdfgen.clientLogo' ) );
                        jQuery( '.js-preview-image' ).find( 'img' ).attr( 'src', sessionLogo.image ).show();
                    }
                    jQuery( '.js-e-productlist-v2' ).find( '.js-sika-productsheet-list-add-wrap' ).show();
                }
                else {
                    jQuery( '.js-create-datasheet' ).prop( 'checked', false );
                    jQuery( '.js-create-datasheet-clientlogo' ).prop( 'checked', false );
                    jQuery( '.js-e-productlist-v2' ).find( '.js-sika-productsheet-list-add-wrap' ).hide();
                }
            }
        },
        selection: function ( initialLoad ) {
            var jList = jQuery( '.js-e-productlist-v2' );
            if ( initialLoad === true ) {
                jList.on( 'click', '.js-sika-productsheet-list-add', function () {
                    var checkedItems = jList.find( '.js-sika-productsheet-list-add' ).filter( ':checked' ).length;
                    if ( checkedItems >= 1 ) {
                        jQuery( '.js-sika-productsheet-generate' ).removeClass( 'd-none' );
                        var prodID    = jQuery( this ).val(),
                            variantID = jQuery( this ).data( 'variantId' );
                        if ( jQuery( this ).is( ':checked' ) ) {
                            sika.productsheet.getPDFdata( prodID, variantID, sika.productsheet.addSelection, jQuery( this ).data( 'variantColor' ) );
                        }
                        else {
                            sessionStorage.removeItem( 'sika.pdfgen.' + sika.productsheet.context + '.item.' + prodID );
                        }
                    }
                    else {
                        jList.find( '.js-sika-productsheet-generate' ).addClass( 'd-none' );
                        var jLocalAllItems = Object.keys( sessionStorage );
                        for ( var i = 0; i < jLocalAllItems.length; i++ ) {
                            if ( jLocalAllItems[ i ].indexOf( 'sika.pdfgen' ) > -1 ) {
                                sessionStorage.removeItem( jLocalAllItems[ i ] );
                            }
                        }
                    }
                } );
            }
        },
        addSelection: function ( data, prodID ) {
            data.product.variantID = jQuery( '#sheet-' + prodID ).find( '[data-name="VariantID"]' ).data( 'value' );
            sessionStorage.setItem( 'sika.pdfgen.' + sika.productsheet.context + '.item.' + prodID, JSON.stringify( data ) );
        },
        filterSelection: function ( jList ) {
            var jArray = [];
            jList.find( '.js-sika-productsheet-list-add' ).filter( ':checked' ).each( function () {
                var jId = jQuery( this ).val();
                jArray.push( jId );
            } );
            return jArray;
        },
        build: function () {
            jQuery( '.js-e-productlist-v2' ).on( 'click', '.js-sika-productsheet-generate', function ( event ) {
                event.preventDefault();
                var jLocalItems          = Object.keys( sessionStorage );
                var jLocalConvertedItems = sika.productsheet.convertLocalItems( jLocalItems );
                jQuery( '.js-e-products-loading-overlay' ).addClass( 'is-loading' );
                sika.productsheet.getScripts( 'list', jLocalConvertedItems );
            } );
            jQuery( '.js-e-product' ).on( 'click', '.js-sika-productsheet-generate', function ( event ) {
                event.preventDefault();
                if ( jQuery( '.js-sika-productsheet-generate-variant-images' ).find( 'li' ).length > 1 ) {
                    jQuery( '.js-sika-productsheet-generate-variant-images' ).slideToggle( 'fast' );
                }
                else {
                    var prodID = jQuery( '.js-e-product' ).data( 'id' );
                    jQuery( '.js-e-products-loading-overlay' ).addClass( 'is-loading' );
                    var variantImage = jQuery( '.js-sika-productsheet-generate-variant-images' ).find( 'li' ).first().find( '.js-sika-productsheet-generate-variant-image' ).data( 'image' );
                    if ( variantImage ) {
                        sika.productsheet.colorVariantImage = '/admin/public/getimage.ashx?image=' + variantImage + '&crop=0&fix=br&Width=800';
                        jQuery( '#image-img-' + prodID ).attr( 'src', '/admin/public/getimage.ashx?image=' + variantImage + '&crop=0&fix=br&Width=800' );
                    }
                    sika.productsheet.getScripts( 'details', prodID );
                }
            } ).on( 'click', '.js-sika-productsheet-generate-variant-image', function ( event ) {
                event.preventDefault();
                var prodID                          = jQuery( '.js-e-product' ).data( 'id' ),
                    variantImage                    = jQuery( this ).data( 'image' ),
                    colorCode                       = jQuery( this ).data( 'color' );
                sika.productsheet.selectedColorCode = colorCode.replace( 'C-', '' );
                if ( variantImage ) {
                    sika.productsheet.colorVariantImage = '/admin/public/getimage.ashx?image=' + variantImage + '&crop=0&fix=br&Width=800';
                    jQuery( '#image-img-' + prodID ).attr( 'src', '/admin/public/getimage.ashx?image=' + variantImage + '&crop=0&fix=br&Width=800' );
                }
                jQuery( '.js-e-products-loading-overlay' ).addClass( 'is-loading' );
                sika.productsheet.getScripts( 'details', prodID );
            } );
        },
        convertLocalItems: function ( jLocalItems ) {
            var jLocalConvertedItems = [];
            for ( var i = 0; i < jLocalItems.length; i++ ) {
                if ( jLocalItems[ i ].indexOf( 'sika.pdfgen.' + sika.productsheet.context + '.item.' ) > -1 ) {
                    jLocalItems[ i ] = jLocalItems[ i ].replace( 'sika.pdfgen.' + sika.productsheet.context + '.item.', '' );
                    jLocalConvertedItems.push( jLocalItems[ i ] );
                }
            }
            return jLocalConvertedItems;
        },
        generatelist: function ( jProducts ) {
            var jHeadlines  = eval( jQuery( '#pdf-list-translations' ).html() ),
                jData       = [],
                jClientLogo = JSON.parse( sessionStorage.getItem( 'sika.pdfgen.clientLogo' ) ),
                promises    = [];
            if ( jClientLogo !== null ) {
                jData.push( {
                    columns: [
                        {
                            text: '',
                            width: '*'
                        },
                        {
                            image: jClientLogo.image,
                            width: jClientLogo.width,
                            height: jClientLogo.height
                        }
                    ]
                } );
            }
            var jLocalAllItems = Object.keys( sessionStorage ),
                arrProducts    = [];
            for ( var s = 0; s < jLocalAllItems.length; s++ ) {
                if ( jLocalAllItems[ s ].indexOf( 'sika.pdfgen.' + sika.productsheet.context + '.item.' ) > -1 ) {
                    arrProducts.push( JSON.parse( sessionStorage.getItem( jLocalAllItems[ s ] ) ) );
                }
            }
            if ( sika.productsheet.debug ) {
                console.group( 'PDF LIST CREATION' );
            }
            arrProducts.forEach( function ( productItem, index ) {
                sika.productsheet.footer.logo = productItem.footerLogo;
                sika.productsheet.footer.text = productItem.footerText;
                if ( sika.productsheet.debug ) {
                    console.log( 'Begin product ', productItem.product.id );
                    console.log( productItem );
                }
                promises.push( function () {
                    return jQuery.Deferred( function ( maindfd ) {
                        eval( jQuery( '.js-create-data-' + productItem.product.id ).html() );
                        var jLocalItem = productItem;
                        var jIcon      = [],
                            jImage     = '',
                            jBrand     = '',
                            jTitle     = jLocalItem.product.name,
                            jNumber    = jLocalItem.product.number,
                            jDesc      = jLocalItem.pdf.ProductDescription,
                            jSize      = jLocalItem.pdf.ProductSize;
                        if ( sika.productsheet.debug ) {
                            console.log( 'Product data', productItem.product.id, jLocalItem.pdf );
                        }
                        sika.productsheet.getDataUri( jLocalItem.pdf.ProductImage, function ( dataUri ) {
                            jImage = dataUri;
                            if ( sika.productsheet.debug ) {
                                console.log( 'Got product ', productItem.product.id, 'Image' );
                            }
                            sika.productsheet.getDataUri( jLocalItem.pdf.ProductBrand, function ( dataUri ) {
                                jBrand = dataUri;
                                if ( sika.productsheet.debug ) {
                                    console.log( 'Got product ', productItem.product.id, 'Brand' );
                                }
                                var iconPromises = [];
                                var productIcons = jLocalItem.pdf.ProductIcons;
                                Object.keys( productIcons ).forEach( function ( key, iconIndex ) {
                                    ( function ( index ) {
                                        var dfd = jQuery.Deferred();
                                        sika.productsheet.getDataUri( productIcons[ key ], function ( dataUri ) {
                                            dfd.resolve( dataUri );
                                            if ( sika.productsheet.debug ) {
                                                console.log( 'Got product ', productItem.product.id, 'Icon', productIcons[ key ] );
                                            }
                                            jIcon.push( {
                                                key: key,
                                                image: dataUri
                                            } );
                                        } );
                                        iconPromises.push( dfd );
                                    } )( iconIndex );
                                } );
                                jQuery.when.apply( jQuery, iconPromises ).then( function () {
                                    if ( sika.productsheet.debug ) {
                                        console.log( 'Got icons ', productItem.product.id );
                                        console.log( jIcon );
                                    }
                                    var jIconSet = jIcon.sort( function ( a, b ) {
                                        if ( a.key < b.key ) {
                                            return -1;
                                        }
                                        if ( a.key > b.key ) {
                                            return 1;
                                        }
                                        return 0;
                                    } );
                                    if ( jSize === 'FALSE' ) {
                                        jSize = '';
                                    }
                                    var iconSet = [];
                                    if ( jIconSet.length > 0 ) {
                                        for ( var i = 0; i < jIconSet.length; i++ ) {
                                            if ( jIconSet[ i ].image !== '' ) {
                                                iconSet.push( {
                                                    image: jIconSet[ i ].image,
                                                    width: 18
                                                } );
                                            }
                                        }
                                    }
                                    var jSet = [
                                        {
                                            id: index,
                                            prodNo: productItem.product.number,
                                            columns: [
                                                {
                                                    style: 'table',
                                                    table: {
                                                        headerRows: 1,
                                                        body: [
                                                            [
                                                                {
                                                                    width: 80,
                                                                    image: jBrand === undefined ? sika.productsheet.fallback() : jBrand,
                                                                    margin: [
                                                                        0,
                                                                        10,
                                                                        0,
                                                                        0
                                                                    ]
                                                                },
                                                                {
                                                                    text: jNumber + ' ' + jTitle,
                                                                    style: 'tableHeader',
                                                                    margin: [
                                                                        0,
                                                                        10,
                                                                        0,
                                                                        0
                                                                    ]
                                                                }
                                                            ],
                                                            [
                                                                {
                                                                    width: 100,
                                                                    height: 100,
                                                                    image: jImage
                                                                },
                                                                {
                                                                    table: {
                                                                        body: [
                                                                            [
                                                                                {
                                                                                    text: sika.productsheet.truncateDescription(jDesc, 600),
                                                                                    style: 'breadtext'
                                                                                }
                                                                            ],
                                                                            [
                                                                                {
                                                                                    text: jHeadlines[ sika.productsheet.lang ][ 0 ].Size + ': ' + jSize,
                                                                                    style: 'breadtext'
                                                                                }
                                                                            ],
                                                                            [
                                                                                {
                                                                                    columns: [
                                                                                        {
                                                                                            columnGap: 5,
                                                                                            columns: iconSet
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        ]
                                                                    },
                                                                    layout: 'noBorders'
                                                                }
                                                            ],
                                                            [
                                                                '',
                                                                ''
                                                            ]
                                                        ]
                                                    },
                                                    layout: 'lightHorizontalLines'
                                                }
                                            ]
                                        }
                                    ];
                                    if ( sika.productsheet.debug ) {
                                        console.log( 'Set build ', productItem.product.id );
                                        console.log( 'Resolved', jSet );
                                    }
                                    jData.push( jSet );
                                    maindfd.resolve( jSet );
                                } );
                            } );
                        } );
                    } ).promise();
                } );
            } );
            jQuery.when( sika.productsheet.allPromises( promises ) ).then( function ( arrPromises ) {
                if ( sika.productsheet.debug ) {
                    console.log( 'jData', jData );
                    console.log( 'promises', promises );
                    console.log( 'List READY' );
                }
                if ( sika.productsheet.debug ) {
                    console.group( 'Sort products' );
                    console.log( 'Before', jData );
                }
                var sortedjData = jData.sort( function ( a, b ) {
                    if ( a[ 0 ] && a[ 0 ].prodNo && b[ 0 ] && b[ 0 ].prodNo ) {
                        var sortByA = a[ 0 ].prodNo,
                            sortByB = b[ 0 ].prodNo;
                        if ( sortByA < sortByB ) {
                            return -1;
                        }
                        if ( sortByA > sortByB ) {
                            return 1;
                        }
                        return 0;
                    }
                    return 0;
                } );
                sortedjData.forEach( function ( elm, index ) {
                    if(elm !== undefined && elm.length && elm[ 0 ].hasOwnProperty('id')){
                        elm[ 0 ].id = (index + 1);
                    }
                    
                } );
                if ( sika.productsheet.debug ) {
                    console.log( 'After', sortedjData );
                    console.groupEnd();
                }
                sika.productsheet.createlist( sortedjData );
            } );
            if ( sika.productsheet.debug ) {
                console.groupEnd();
            }
        },
        generatesingle: function ( data ) {
            var jIndustryAll = '',
                jIndustry    = data.pdf.ProductIndustry;
            if ( jIndustry === ', ' ) {
                jIndustry = '';
            }
            for ( var i = 0; i < jIndustry.length; i++ ) {
                if ( i > 0 ) {
                    jIndustryAll += ', ';
                }
                if ( jIndustry[ i ] !== '' ) {
                    jIndustryAll += jIndustry[ i ];
                }
            }
            var jHeadlines      = eval( jQuery( '#pdf-details-translations' ).html() ),
                jIcon           = [],
                jImage          = '',
                jClientLogo     = jQuery( '.js-create-clientlogo' ).attr( 'src' ),
                jTitle          = data.product.name,
                jNumber         = data.product.number,
                jDesc           = data.pdf.ProductDescription.replace( /&nbsp;/gi, ' ' ).replace( /&reg;/gi, '®' ).replace( /&aring;/gi, 'å' ).replace( /&aelig;/gi, 'æ' ).replace( /&oslash;/gi, 'ø' ),
                jSize           = data.pdf.ProductSize,
                jBrandImg       = '',
                jSerie          = data.pdf.ProductSerie,
                jSpecial        = data.pdf.ProductSpecial.replace( ';', ', ' ),
                jOutersole      = data.pdf.ProductOutersole,
                jTopleather     = data.pdf.ProductTopleather,
                jInnerfor       = data.pdf.ProductInnerfor,
                jInnersole      = data.pdf.ProductInnersole,
                jInnersoleExtra = data.pdf.ProductInnersoleExtraText !== undefined ? data.pdf.ProductInnersoleExtraText : '',
                jCeNorm         = data.pdf.ProductCeNorm,
                jHeader         = {},
                jBodyStart      = [],
                jBodyEnd        = [];
            var promises = [];
            var productImage = data.pdf.ProductImage;

            if ( sika.productsheet.colorVariantImage !== undefined ) {
                productImage = sika.productsheet.colorVariantImage;
            }
            

            sika.productsheet.getDataUri( productImage, function ( dataUri ) {
                jImage = dataUri;
                sika.productsheet.getDataUri( data.pdf.ProductBrand, function ( dataUri ) {
                    jBrandImg        = dataUri;
                    var productIcons = data.pdf.ProductIcons;
                    Object.keys( productIcons ).forEach( function ( key, iconIndex ) {
                        ( function ( index ) {
                            if ( productIcons[ key ] !== '' ) {
                                var dfd = jQuery.Deferred();
                                sika.productsheet.getDataUri( productIcons[ key ], function ( dataUri ) {
                                    dfd.resolve( dataUri );
                                    jIcon.push( {
                                        key: key,
                                        image: dataUri
                                    } );
                                } );
                                promises.push( dfd );
                            }
                        } )( iconIndex );
                    } );
                    jQuery.when.apply( jQuery, promises ).then( function () {
                        sika.productsheet.pdfTitle = jNumber.replace( ' ', '-' ) + '_' + jTitle.replace( ' ', '-' );
                        jHeader.columns      = [];
                        jHeader.columns[ 0 ] = {};
                        jHeader.columns[ 1 ] = {};
                        jHeader.columns[ 2 ] = {};
                        if ( jClientLogo !== '' ) {
                            jHeader.columns[ 0 ].height = sika.productsheet.clientLogo.height;
                            jHeader.columns[ 0 ].width  = sika.productsheet.clientLogo.width;
                            jHeader.columns[ 0 ].image  = jClientLogo;
                            jHeader.columns[ 0 ].margin = [
                                0,
                                5,
                                0,
                                10
                            ];
                        }
                        else {
                            jHeader.columns[ 0 ].text = '';
                        }
                        jHeader.columns[ 1 ].text  = '';
                        jHeader.columns[ 1 ].width = '*';
                        jHeader.columns[ 2 ].width  = 100;
                        jHeader.columns[ 2 ].image  = jBrandImg !== undefined ? jBrandImg : sika.productsheet.fallback();
                        jHeader.columns[ 2 ].margin = [
                            0,
                            10,
                            0,
                            0
                        ];
                        jBodyStart[ 0 ]           = [];
                        jBodyStart[ 0 ][ 0 ]      = {};
                        jBodyStart[ 0 ][ 1 ]      = {};
                        jBodyStart[ 1 ]           = [];
                        jBodyStart[ 1 ][ 0 ]      = {};
                        jBodyStart[ 1 ][ 1 ]      = [];
                        jBodyStart[ 1 ][ 1 ][ 0 ] = {};
                        jBodyStart[ 1 ][ 1 ][ 1 ] = {};
                        jBodyStart[ 0 ][ 0 ].text    = '';
                        jBodyStart[ 0 ][ 0 ].colSpan = 2;
                        jBodyStart[ 0 ][ 1 ].text    = '';
                        //Product image
                        
                        jBodyStart[ 1 ][ 0 ].image  = jImage !== '' ? jImage : sika.productsheet.fallback();
                        jBodyStart[ 1 ][ 0 ].width  = 220;
                        jBodyStart[ 1 ][ 0 ].height = 220;
                        //Headline
                        jBodyStart[ 1 ][ 1 ][ 0 ].text   = jNumber + ' ' + jTitle;
                        jBodyStart[ 1 ][ 1 ][ 0 ].margin = [
                            0,
                            10,
                            0,
                            0
                        ];
                        jBodyStart[ 1 ][ 1 ][ 0 ].style  = 'tableHeader';
                        //Description
                        jBodyStart[ 1 ][ 1 ][ 1 ].text   = jDesc.replace( '&nbsp;', ' ' );
                        jBodyStart[ 1 ][ 1 ][ 1 ].margin = [
                            0,
                            10,
                            0,
                            0
                        ];
                        jBodyStart[ 1 ][ 1 ][ 1 ].style  = 'breadtext';
                        //Table
                        var jCol = -1;
                        if ( jCeNorm !== '' ) {
                            jCol++;
                            jBodyEnd[ jCol ]            = [];
                            jBodyEnd[ jCol ][ 0 ]       = {};
                            jBodyEnd[ jCol ][ 1 ]       = {};
                            jBodyEnd[ jCol ][ 0 ].text  = 'CE Norm';
                            jBodyEnd[ jCol ][ 0 ].style = 'tableBold';
                            jBodyEnd[ jCol ][ 1 ].text  = jCeNorm;
                            jBodyEnd[ jCol ][ 1 ].style = 'tableLight';
                        }
                        if ( jSerie !== '' ) {
                            jCol++;
                            jBodyEnd[ jCol ]            = [];
                            jBodyEnd[ jCol ][ 0 ]       = {};
                            jBodyEnd[ jCol ][ 1 ]       = {};
                            jBodyEnd[ jCol ][ 0 ].text  = jHeadlines[ sika.productsheet.lang ][ 0 ].Serie;
                            jBodyEnd[ jCol ][ 0 ].style = 'tableBold';
                            jBodyEnd[ jCol ][ 1 ].text  = jSerie;
                            jBodyEnd[ jCol ][ 1 ].style = 'tableLight';
                        }
                        if ( jSpecial !== '' && jSpecial !== 'NA' ) {
                            jCol++;
                            jBodyEnd[ jCol ]            = [];
                            jBodyEnd[ jCol ][ 0 ]       = {};
                            jBodyEnd[ jCol ][ 1 ]       = {};
                            jBodyEnd[ jCol ][ 0 ].text  = jHeadlines[ sika.productsheet.lang ][ 1 ].Special;
                            jBodyEnd[ jCol ][ 0 ].style = 'tableBold';
                            jBodyEnd[ jCol ][ 1 ].text  = jSpecial;
                            jBodyEnd[ jCol ][ 1 ].style = 'tableLight';
                        }
                        if ( jOutersole !== '' && jOutersole !== 'NA' ) {
                            jCol++;
                            jBodyEnd[ jCol ]            = [];
                            jBodyEnd[ jCol ][ 0 ]       = {};
                            jBodyEnd[ jCol ][ 1 ]       = {};
                            jBodyEnd[ jCol ][ 0 ].text  = jHeadlines[ sika.productsheet.lang ][ 2 ].Outersole;
                            jBodyEnd[ jCol ][ 0 ].style = 'tableBold';
                            jBodyEnd[ jCol ][ 1 ].text  = jOutersole;
                            jBodyEnd[ jCol ][ 1 ].style = 'tableLight';
                        }
                        if ( jTopleather !== '' && jTopleather !== 'NA' ) {
                            jCol++;
                            jBodyEnd[ jCol ]            = [];
                            jBodyEnd[ jCol ][ 0 ]       = {};
                            jBodyEnd[ jCol ][ 1 ]       = {};
                            jBodyEnd[ jCol ][ 0 ].text  = jHeadlines[ sika.productsheet.lang ][ 3 ].Topleather;
                            jBodyEnd[ jCol ][ 0 ].style = 'tableBold';
                            jBodyEnd[ jCol ][ 1 ].text  = jTopleather;
                            jBodyEnd[ jCol ][ 1 ].style = 'tableLight';
                        }
                        if ( jInnerfor !== '' && jInnerfor !== 'NA' ) {
                            jCol++;
                            jBodyEnd[ jCol ]            = [];
                            jBodyEnd[ jCol ][ 0 ]       = {};
                            jBodyEnd[ jCol ][ 1 ]       = {};
                            jBodyEnd[ jCol ][ 0 ].text  = jHeadlines[ sika.productsheet.lang ][ 4 ].Innerfor;
                            jBodyEnd[ jCol ][ 0 ].style = 'tableBold';
                            jBodyEnd[ jCol ][ 1 ].text  = jInnerfor;
                            jBodyEnd[ jCol ][ 1 ].style = 'tableLight';
                        }
                        if ( jInnersole !== '' && jInnersole !== 'NA' ) {
                            jCol++;
                            jBodyEnd[ jCol ]            = [];
                            jBodyEnd[ jCol ][ 0 ]       = {};
                            jBodyEnd[ jCol ][ 1 ]       = {};
                            jBodyEnd[ jCol ][ 0 ].text  = jHeadlines[ sika.productsheet.lang ][ 5 ].Innersole;
                            jBodyEnd[ jCol ][ 0 ].style = 'tableBold';
                            jBodyEnd[ jCol ][ 1 ].text  = jInnersole + ( jInnersoleExtra !== '' ? '\n' + jInnersoleExtra : '' );
                            jBodyEnd[ jCol ][ 1 ].style = 'tableLight';
                        }
                        if ( jIndustry !== '' && jIndustry !== ', ' && jIndustry !== 'Hide' ) {
                            jCol++;
                            jBodyEnd[ jCol ]            = [];
                            jBodyEnd[ jCol ][ 0 ]       = {};
                            jBodyEnd[ jCol ][ 1 ]       = {};
                            jBodyEnd[ jCol ][ 0 ].text  = jHeadlines[ sika.productsheet.lang ][ 6 ].Industry;
                            jBodyEnd[ jCol ][ 0 ].style = 'tableBold';
                            jBodyEnd[ jCol ][ 1 ].text  = jIndustry;
                            jBodyEnd[ jCol ][ 1 ].style = 'tableLight';
                        }
                        if ( jSize !== '' && jSize !== 'FALSE' ) {
                            jCol++;
                            jBodyEnd[ jCol ]            = [];
                            jBodyEnd[ jCol ][ 0 ]       = {};
                            jBodyEnd[ jCol ][ 1 ]       = {};
                            jBodyEnd[ jCol ][ 0 ].text  = jHeadlines[ sika.productsheet.lang ][ 7 ].Size;
                            jBodyEnd[ jCol ][ 0 ].style = 'tableBold';
                            jBodyEnd[ jCol ][ 1 ].text  = jSize;
                            jBodyEnd[ jCol ][ 1 ].style = 'tableLight';
                        }
                        if ( !jBodyEnd.length ) {
                            jBodyEnd = [
                                {
                                    'text': ''
                                }
                            ];
                        }
                        var jIconSet = jIcon.sort( function ( a, b ) {
                            if ( a.key < b.key ) {
                                return -1;
                            }
                            if ( a.key > b.key ) {
                                return 1;
                            }
                            return 0;
                        } );
                        var iconSet  = [];
                        if ( sika.productsheet.debug ) {
                            console.log( jIconSet );
                        }
                        if ( jIconSet.length > 0 ) {
                            for ( var i = 0; i < jIconSet.length; i++ ) {
                                if ( jIconSet[ i ].image !== '' ) {
                                    iconSet.push( {
                                        image: jIconSet[ i ].image,
                                        width: 22
                                    } );
                                }
                            }
                        }
                        var jSet = [
                            jHeader,
                            {
                                style: 'table',
                                table: {
                                    headerRows: 1,
                                    body: jBodyStart
                                },
                                layout: 'lightHorizontalLines'
                            },
                            {
                                columns: [
                                    {
                                        columnGap: 5,
                                        columns: iconSet
                                    }
                                ]
                            },
                            {
                                style: 'table',
                                table: {
                                    headerRows: 1,
                                    body: jBodyEnd
                                },
                                layout: 'lightHorizontalLines'
                            }
                        ];
                        sika.productsheet.createsingle( jSet );
                    } );
                } );
            } );
        },
        fallback: function () {
            return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=';
        },
        getDataUri: function ( strUrl, fnCallback ) {

            var image     = new Image();
            image.onload  = function () {
                var canvas    = document.createElement( 'canvas' );
                canvas.width  = this.naturalWidth;
                canvas.height = this.naturalHeight;
                canvas.getContext( '2d' ).drawImage( this, 0, 0 );
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( canvas.toDataURL( 'image/png' ) );
                }
                else {
                    return canvas.toDataURL( 'image/png' );
                }
            };
            image.onerror = function (err) {
                console.error(err);
                fnCallback( '' );
            };
            image.src     = strUrl;
        },
        clientLogoUpload: {
            show: function () {
                var prodID = jQuery( '.js-e-product' ).data( 'id' );
                jQuery( '.js-sika-productsheet-clientlogo' ).on( 'click', function () {
                    if ( jQuery( '.js-sika-productsheet-clientlogo-variant-images' ).find( 'li' ).length > 1 ) {
                        if ( jQuery( '.pdf-client-logo-file' ).is( ':visible' ) === true ) {
                            jQuery( '.pdf-client-logo-file' ).slideToggle( 'fast' );
                        }
                        else {
                            jQuery( '.js-sika-productsheet-clientlogo-variant-images' ).slideToggle( 'fast' );
                        }
                    }
                    else {
                        jQuery( '.pdf-client-logo-file' ).slideToggle( 'fast' );
                        var variantImage = jQuery( '.js-sika-productsheet-generate-variant-images' ).find( 'li' ).first().find( '.js-sika-productsheet-generate-variant-image' ).data( 'image' );
                        if ( variantImage ) {
                            sika.productsheet.colorVariantImage = '/admin/public/getimage.ashx?image=' + variantImage + '&crop=0&fix=br&Width=800';
                        }
                    }
                } );
                jQuery( '.js-sika-productsheet-clientlogo-variant-images' ).on( 'click', '.js-sika-productsheet-clientlogo-variant-image', function ( event ) {
                    event.preventDefault();
                    var variantImage                    = jQuery( this ).attr( 'href' );
                    var colorCode                       = jQuery( this ).data( 'color' );
                    sika.productsheet.selectedColorCode = colorCode.replace( 'C-', '' );
                    if ( variantImage ) {
                        sika.productsheet.colorVariantImage = '/admin/public/getimage.ashx?image=' + variantImage + '&crop=0&fix=br&Width=800';
                        jQuery( '#image-img-' + prodID ).attr( 'src', '/admin/public/getimage.ashx?image=' + variantImage + '&crop=0&fix=br&Width=800' );
                    }
                    jQuery( '.js-sika-productsheet-clientlogo-variant-images' ).slideToggle( 'fast' );
                    jQuery( '.pdf-client-logo-file' ).slideToggle( 'fast' );
                } );
            },
            attachDetails: function () {
                jQuery( '#pdfClientLogo' ).on( 'change', function ( event ) {
                    var files   = event.target.files,
                        jWidth  = 0,
                        jHeight = 0;
                    for ( var i = 0, f; f = files[ i ]; i++ ) {
                        if ( !f.type.match( 'image.*' ) ) {
                            continue;
                        }
                        var reader    = new FileReader();
                        reader.onload = ( function () {
                            return function ( e ) {
                                //console.log('wtf',e.target.result);
                                jQuery( '.js-create-clientlogo' ).attr( 'src', e.target.result );
                                jQuery( '<img src="' + e.target.result + '" />' ).appendTo( 'body' ).css( {
                                    'position': 'absolute',
                                    'top': -10000
                                } ).on( 'load', function () {
                                    jWidth  = jQuery( this ).width();
                                    jHeight = jQuery( this ).height();
                                    jQuery( this ).remove();
                                    sika.productsheet.recalculateImage( 'clientLogo', jWidth, jHeight, sika.productsheet.clientLogoUpload.buildDetails );
                                } );
                            };
                        } )( f );
                        reader.readAsDataURL( f );
                    }
                } );
            },
            attachList: function () {
                jQuery( '#pdfClientLogoList' ).on( 'change', function ( event ) {
                    var files   = event.target.files,
                        jWidth  = 0,
                        jHeight = 0;
                    for ( var i = 0, f; f = files[ i ]; i++ ) {
                        if ( !f.type.match( 'image.*' ) ) {
                            continue;
                        }
                        var reader    = new FileReader();
                        
                        reader.onload = ( function () {
                            return function ( e ) {
                                jQuery( '<img src="' + e.target.result + '" />' ).appendTo( 'body' ).css( {
                                    'position': 'absolute',
                                    'top': -10000
                                } ).on( 'load', function () {
                                    jWidth  = jQuery( this ).width();
                                    jHeight = jQuery( this ).height();
                                    jQuery( this ).remove();
                                    sika.productsheet.recalculateImage( 'clientLogo', jWidth, jHeight, sika.productsheet.clientLogoUpload.setLocalLogo, e.target.result );
                                    jQuery( '.file-upload-wrapper' ).slideUp( 'fast', function () {
                                        jQuery( '.js-preview-image' ).find( 'img' ).attr( 'src', e.target.result );
                                        jQuery( '.js-preview-image' ).removeClass( 'd-none' ).find( 'img' ).show();
                                    } );
                                } );
                            };
                        } )( f );
                        
                        reader.readAsDataURL( f );
                    }
                } );
            },
            removeList: function () {
                jQuery( '.js-delete-client-logo' ).on( 'click', function () {
                    jQuery( '.js-preview-image' ).addClass( 'd-none' );
                    jQuery( '.js-preview-image' ).find( 'img' ).attr( 'src', '' );
                    jQuery( '#pdfClientLogoList' ).val( '' );
                    sessionStorage.removeItem( 'sika.pdfgen.clientLogo' );
                    jQuery( '.file-upload-wrapper' ).slideDown( 'fast' );
                } );
            },
            buildDetails: function () {
                var jProduct = jQuery( '.js-e-product' ).data( 'id' );
                jQuery( '.js-e-products-loading-overlay' ).addClass( 'is-loading' );
                sika.productsheet.getScripts( 'details', jProduct );
            },
            setLocalLogo: function ( jImage, jWidth, jHeight ) {
                var clientLogo = {
                    image: jImage,
                    width: jWidth,
                    height: jHeight
                };
                sessionStorage.setItem( 'sika.pdfgen.clientLogo', JSON.stringify( clientLogo ) );
            },
            init: function () {
                this.show();
                this.attachDetails();
                this.attachList();
                this.removeList();
            }
        },
        createsingle: function ( jData ) {
            var productSheet = {
                pageSize: 'A4',
                pageMargins: [
                    50,
                    40,
                    50,
                    0
                ],
                footer: function () {
                    return sika.productsheet.getPDFFooter();
                },
                content: jData,
                styles: {
                    table: {
                        margin: [
                            0,
                            5,
                            0,
                            15
                        ]
                    },
                    tableHeader: {
                        fontSize: 20,
                        bold: true,
                        alignment: 'left',
                        margin: [
                            0,
                            0,
                            0,
                            10
                        ]
                    },
                    tableBold: {
                        bold: true,
                        fontSize: 10
                    },
                    tableLight: {
                        bold: false,
                        fontSize: 10
                    },
                    breadtext: {
                        fontSize: 10
                    }
                }
            };
            if ( sika.productsheet.debug ) {
                console.log( 'Do download title', sika.productsheet.pdfTitle );
                console.log( 'Do download object', productSheet );
            }
            try {
                pdfMake.createPdf( productSheet ).download( sika.productsheet.pdfTitle + '.pdf' );
                pdfMake.createPdf( productSheet ).getDataUrl( function () {
                    jQuery( '.js-e-products-loading-overlay' ).removeClass( 'is-loading' );
                    jQuery( '.pdf-client-logo-file' ).slideUp( 'fast' );
                    jQuery( '.js-create-clientlogo' ).attr( 'src', '' );
                    jQuery( '#pdfClientLogo' ).val( '' );
                } );
            }
            catch ( err ) {
                console.error( err );
            }
        },
        pageBreaks: function(){
            var returnValue = [];
            for ( var i = 4; i < 100; i+=3 ){
                returnValue.push(i);
            }
            return returnValue;
        },
        createlist: function ( jData ) {
            if ( sika.productsheet.debug ) {
                console.log( 'createList', jData );
            }
            if ( jData.length > 0 ) {
                var productSheet = {
                    pageSize: 'A4',
                    pageMargins: [
                        50,
                        40,
                        50,
                        50
                    ],
                    footer: function () {
                        return sika.productsheet.getPDFFooter();
                    },
                    pageBreakBefore: function ( currentNode ) {
                        if(sika.productsheet.pageBreaks().indexOf(currentNode.id) > -1){
                            return true;
                        }
                        return false;
                    },
                    content: jData,
                    styles: {
                        table: {
                            margin: [
                                0,
                                5,
                                0,
                                5
                            ]
                        },
                        tableHeader: {
                            fontSize: 20,
                            bold: true,
                            alignment: 'left',
                            margin: [
                                0,
                                10,
                                0,
                                10
                            ]
                        },
                        tableBold: {
                            bold: true,
                            fontSize: 10
                        },
                        tableLight: {
                            bold: false,
                            fontSize: 10
                        },
                        breadtext: {
                            fontSize: 10
                        }
                    }
                };
                try {
                    if ( window.navigator.msSaveBlob ) {
                        pdfMake.createPdf( productSheet ).getBuffer( function ( buffer ) {
                            var blob = new Blob( [ buffer ] );
                            window.navigator.msSaveBlob( blob, 'sika-product-list.pdf' );
                        } );
                    }
                    else {
                        pdfMake.createPdf( productSheet ).download( 'sika-product-list.pdf' );
                    }
                    pdfMake.createPdf( productSheet ).getDataUrl( function () {
                        sika.shoefinder.loader.hide();
                        jQuery( '.js-e-products-loading-overlay' ).removeClass( 'is-loading' );
                        sika.productsheet.clearlist();
                    } );
                }
                catch ( err ) {
                    console.error( err );
                }
            }
        },
        getPDFFooter: function () {
            var version = sika.productsheet.getPDFVersion();
            return {
                margin: [
                    50,
                    -50,
                    50,
                    0
                ],
                height: 50,
                columns: [
                    {
                        image: sika.productsheet.footer.logo,
                        width: 150,
                        height: 37
                    },
                    {
                        text: [
                            {
                                text: sika.productsheet.footer.text,
                                bold: true,
                                style: { fontSize: 9 }
                            }
                        ],
                        margin: [
                            0,
                            4,
                            0,
                            0
                        ],
                        width: 220
                    },
                    {
                        alignment: 'right',
                        text: [
                            {
                                text: version,
                                style: { fontSize: 8 }
                            }
                        ],
                        margin: [
                            0,
                            20,
                            0,
                            0
                        ],
                        width: '*'
                    }
                ],
                columnGap: 10
            }
        },
        getPDFVersion: function () {
            var today      = new Date(),
                todayDate  = today.getDate(),
                todayMonth = today.getMonth() + 1,
                todayYear  = today.getFullYear();
            todayMonth     = parseInt( todayMonth ) < 10 ? '0' + todayMonth : todayMonth;
            return 'Version: ' + todayDate + todayMonth + '-' + todayYear;
        },
        recalculateImage: function ( jType, jWidth, jHeight, callback, data ) {
            //console.log(callback);
            var maxWidth  = 150,
                maxHeight = 50,
                ratio     = 0,
                cbWidth   = 0,
                cbHeight  = 0;
            if ( jWidth > maxWidth ) {
                ratio                             = maxWidth / jWidth;
                sika.productsheet[ jType ].height = jHeight * ratio;
                sika.productsheet[ jType ].width  = jWidth * ratio;
                cbWidth                           = jWidth * ratio;
                cbHeight                          = jHeight * ratio;
            }
            if ( jHeight > maxHeight ) {
                ratio                             = maxHeight / jHeight;
                sika.productsheet[ jType ].width  = jWidth * ratio;
                sika.productsheet[ jType ].height = jHeight * ratio;
                cbWidth                           = jWidth * ratio;
                cbHeight                          = jHeight * ratio;
            }
            if ( callback ) {
                callback( data, cbWidth, cbHeight );
            }
        },
        supportsDataUri: function () {
            var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
            return !isIE11;
        },
        truncateDescription: function ( stringInput, length ) {
            stringInput = stringInput.replace( '&nbsp;', ' ' );
            if ( stringInput.length > length ) {
                return stringInput.substring( 0, length ) + '...';
            }
            return stringInput;
        },
        clearlist: function () {
            var jLocalAllItems = Object.keys( sessionStorage );
            jQuery( '.js-sika-productsheet-list-add-wrap' ).hide();
            jQuery( '.js-create-datasheet' ).prop( 'checked', false );
            jQuery( '.js-create-datasheet-clientlogo' ).prop( 'checked', false );
            jQuery( '.js-sika-productsheet-generate' ).remove();
            jQuery( '.pdf-client-logo-file' ).hide().find( '.file-upload-wrapper' ).show();
            jQuery( '.pdf-client-logo-file' ).find( '.js-preview-image' ).addClass( 'd-none' ).find( 'img' ).attr( 'src', '' );
            if ( jQuery( '.js-sika-shoefinder' ).length === 0 ) {
                for ( var i = 0; i < jLocalAllItems.length; i++ ) {
                    if ( jLocalAllItems[ i ].indexOf( 'sika.pdfgen' ) > -1 ) {
                        sessionStorage.removeItem( jLocalAllItems[ i ] );
                    }
                }
            }
            else {
                e4.util.hash.set( 'mylist', 'download' );
            }
        },
        init: function ( initialLoad ) {
            if ( jQuery( '.js-e-productlist-v2' ).length ) {
                sika.productsheet.addCheckboxes();
            }
            sika.productsheet.checkList();
            sika.productsheet.selection( initialLoad );
            sika.productsheet.build();
            sika.productsheet.clientLogoUpload.init();
            sika.productsheet.testDevice();
        }
    };
}() );

